var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobilesteam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#06addf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ad3a6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430",
    transform: "translate(-286.29 -2636.485)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 94.5,
    cy: 94.5,
    r: 94.5,
    transform: "translate(286.29 2636.485)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_10158390791536041812",
    "data-name": 10158390791536042000,
    transform: "translate(331.182 2681.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M78.522,58.346a1.434,1.434,0,0,0-.089-.245L69.521,39.467a1.477,1.477,0,0,0-1.332-.839H31.22a1.475,1.475,0,0,0-1.333.844L21.06,58.106a.178.178,0,0,1-.008.021A10.588,10.588,0,0,0,13.109,68.36v6.558A10.593,10.593,0,0,0,20.7,85.06v9.493a3.5,3.5,0,0,0,3.7,3.241h4.619a3.5,3.5,0,0,0,3.7-3.241V85.5H66.771v9.056a3.5,3.5,0,0,0,3.7,3.241h4.618a3.5,3.5,0,0,0,3.7-3.241V84.831a10.6,10.6,0,0,0,6.919-9.915V68.359A10.59,10.59,0,0,0,78.522,58.346ZM32.154,41.58h35.1l7.748,16.2H24.48Zm-2.38,52.958a.871.871,0,0,1-.753.3H24.4a.918.918,0,0,1-.751-.288V85.5l.036,0h6.085Zm46.071,0a.876.876,0,0,1-.754.3H70.474a.921.921,0,0,1-.752-.288V85.5h5.415c.237,0,.471-.019.707-.034Zm6.918-19.62a7.652,7.652,0,0,1-7.626,7.627H23.688a7.636,7.636,0,0,1-7.627-7.627V68.36a7.636,7.636,0,0,1,7.627-7.627h51.45a7.636,7.636,0,0,1,7.627,7.627Z",
    transform: "translate(0 -0.579)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M26.838,66.284a5.8,5.8,0,1,0,5.8,5.8A5.8,5.8,0,0,0,26.838,66.284Zm0,8.638a2.844,2.844,0,1,1,2.843-2.844A2.846,2.846,0,0,1,26.838,74.922Z",
    transform: "translate(-0.126 -1.018)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M73.654,65.911a5.8,5.8,0,1,0,5.8,5.8A5.8,5.8,0,0,0,73.654,65.911Zm0,8.638A2.844,2.844,0,1,1,76.5,71.705,2.846,2.846,0,0,1,73.654,74.549Z",
    transform: "translate(-0.871 -1.012)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M56.551,73.212H43.185a1.476,1.476,0,0,0,0,2.952H56.551a1.476,1.476,0,0,0,0-2.952Z",
    transform: "translate(-0.455 -1.129)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M49.879,27.03a7.473,7.473,0,0,0,7.464-7.465c0-3.467-5.108-14.334-6.132-16.478a1.477,1.477,0,0,0-2.665,0C47.522,5.231,42.414,16.1,42.414,19.565A7.474,7.474,0,0,0,49.879,27.03Zm0-19.8c2.111,4.672,4.512,10.561,4.512,12.334a4.513,4.513,0,1,1-9.025,0C45.366,17.793,47.768,11.9,49.879,7.231Z",
    transform: "translate(-0.466 0)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M20.573,27.03a7.474,7.474,0,0,0,7.465-7.465c0-3.467-5.108-14.334-6.132-16.478a1.477,1.477,0,0,0-2.665,0C18.217,5.23,13.108,16.1,13.108,19.564A7.474,7.474,0,0,0,20.573,27.03Zm0-19.8c2.111,4.673,4.512,10.562,4.512,12.335a4.513,4.513,0,1,1-9.026,0C16.06,17.793,18.462,11.9,20.574,7.231Z",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M79.242,27.03a7.474,7.474,0,0,0,7.465-7.465c0-3.467-5.108-14.334-6.133-16.478a1.476,1.476,0,0,0-2.664,0C76.887,5.232,71.779,16.1,71.779,19.566A7.472,7.472,0,0,0,79.242,27.03Zm0-19.8c2.112,4.672,4.513,10.56,4.513,12.334a4.513,4.513,0,1,1-9.025,0C74.73,17.793,77.132,11.9,79.242,7.231Z",
    transform: "translate(-0.933 0)",
    fill: "#fefefe"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilesteam);
export default __webpack_public_path__ + "static/media/mobilesteam.c88f2f0a8d6218898a6bd08637796567.svg";
export { ForwardRef as ReactComponent };